export const cloneMetadata = (metadata) => {
    if (!metadata || typeof metadata !== "object") {
        return {};
    }
    return { ...metadata };
};

export const buildEventMetadataPayload = ({
    draftMetadata,
    editingEventId,
    originalChannelId,
    calendarScopedChannelId,
}) => {
    const base = cloneMetadata(draftMetadata);
    const hasChannelKey = Object.prototype.hasOwnProperty.call(base, "channelId");
    const draftChannelId = hasChannelKey && base.channelId != null && base.channelId !== ""
        ? String(base.channelId)
        : null;
    const normalizedOriginalChannelId = originalChannelId != null ? String(originalChannelId) : null;
    const normalizedScopedChannelId = calendarScopedChannelId != null
        ? String(calendarScopedChannelId)
        : null;
    const isEditing = Boolean(editingEventId);
    const shouldPreserveNeutralChannel = isEditing && normalizedOriginalChannelId == null;

    let resolvedChannelId = draftChannelId;

    if (!resolvedChannelId) {
        if (isEditing && normalizedOriginalChannelId != null) {
            resolvedChannelId = normalizedOriginalChannelId;
        } else if (!shouldPreserveNeutralChannel && normalizedScopedChannelId != null) {
            resolvedChannelId = normalizedScopedChannelId;
        }
    }

    if (resolvedChannelId) {
        return { ...base, channelId: resolvedChannelId };
    }

    if (hasChannelKey) {
        const { channelId: _omit, ...rest } = base;
        return Object.keys(rest).length > 0 ? rest : {};
    }

    if (Object.keys(base).length > 0) {
        return base;
    }

    return null;
};
